module.exports = __webpack_public_path__ + "static/media/Minced_Pork_Rice.a7f7edbd.png";